import { render } from "./event-title.vue?vue&type=template&id=767ff597&lang=pug"
import script from "./event-title.vue?vue&type=script&lang=js"
export * from "./event-title.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__